import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { AppStyles } from "../themes/AppStyles";
import defaultTheme from "../themes";
import Dashboard from "../pages/Dashboard/Dashboard";
// import MonthlyReport from "../pages/Dashboard/DailyPositionReport"
import LobConstants from "../constants/LobConstants";
import RakeDetentionReport from "../pages/reports/RakeDetentionReport";
import TonnageReport from "../pages/reports/TonnageReport";
import TripWiseProfitablityReport from "../pages/reports/tripWiseProfitabilityReport/TripwiseProfitabilityReport";
import IdelWeightReport from "../pages/reports/IdelWeightReport";
// import DailyPositionReport from "../pages/Dashboard/DailyPositionReport/dailyPositionReport";
// import ListReports from "../pages/Dashboard/DailyPositionReport/SearchForm";
import ExecutiveDashboard from "../pages/Dashboard/DailyPositionReport/executiveDashboard";
import SFTOJobdetailsReport from "../pages/reports/sftoJobDetailsReport/sftoJOBDetailsReport";
import GPWISJobDetailsReport from "../pages/reports/gpwisJobDetailsReport/gpwisJOBDetailsReport";
import InvoiceReport from "../pages/reports/invoiceReport/invoiceReport";
import ReportView from "../pages/reports/ReportViews/index";
import RailwaysHomePage from "../views/Home/Railwayshomepage";

const Job = React.lazy(() => import("../views/job"));
const Maintenance = React.lazy(() => import("../views/maintenance"));
const Invoice = React.lazy(() => import("../views/invoice"));
const Dsr = React.lazy(() => import("../views/dsr"));
const DamageWagon = React.lazy(() => import("../views/damageWagon"));
const TrackRake = React.lazy(() => import("../views/trackrake"));
const RakeMaster = React.lazy(() => import("../views/masters/RakeMaster"));
const RouteMaster = React.lazy(() => import("../views/masters/RouteMaster"));
const CommodityMaster = React.lazy(() =>
  import("../views/masters/commoditymaster")
);
const Master = React.lazy(() => import("../views/masters"));
const RakeInduction = React.lazy(() => import("../views/rakeInduction"));
const RakeMaintenance = React.lazy(() => import("../views/rakeMaintenance"));
const ContractDetails = React.lazy(() =>
  import("../views/masters/contractHeaderMaster")
);
const VendorDetails = React.lazy(() => import("../views/masters/vendorMaster"));
const SapTransactionDetails = React.lazy(() =>
  import("../views/saptransactiondetails")
);
const MonthlyReport = React.lazy(() =>
  import("../pages/Dashboard/DailyPositionReport")
);
const ConsolidatedInvoice = React.lazy(() =>
  import("../views/consolidatedInvoice")
);
const MgtInvoice = React.lazy(() =>
  import("../views/mgtInvoice")
);
const ShipToPartyDetails = React.lazy(() =>
  import("../views/masters/shiptopartymaster")
);
const CustomerThresholdMaster = React.lazy(() =>
  import("../views/masters/customerThresholdMaster")
);
const MaterialClassMaster = React.lazy(() =>
  import("../views/masters/MaterialClassMaster")
);
const FrieghtMaster = React.lazy(() =>
  import("../views/masters/FraightMaster")
);
const ExaminationTypeMaster = React.lazy(() =>
  import("../views/masters/ExaminationTypeMaster")
);
const DepoMaster = React.lazy(() => import("../views/masters/DepoMaster"));
const WagonComponentMaster = React.lazy(() =>
  import("../views/masters/WagonComponentMaster")
);
const RohPohScheduleComponentMaster = React.lazy(() =>
  import("../views/masters/RohPohScheduleMaster")
);
const RakeRebateMaster = React.lazy(() =>
  import("../views/masters/RakeRebateMaster")
);
const ODPairMaster = React.lazy(() => import("../views/masters/ODPairMaster"));

const TATReconciliationMaster = React.lazy(() => import("../views/masters/TATReconciliationMaster"));
const RakeRebateInvoice = React.lazy(() => import("../views/rakeRebateInvoice/RakeRebateInvoice"));
const StationMaster = React.lazy(() => import("../views/masters/StationMaster"));
const SFTOReconciliationRouts = React.lazy(() => import("../views/sftoReconciliation/index"));


export default function App() {
  const [state, setState] = React.useState({
    theme: defaultTheme.default,
    rightDrawerOpen: false,
    navDrawerOpen:
      window &&
        window.innerWidth &&
        window.innerWidth >= defaultTheme.default.breakpoints.values.md
        ? true
        : false,
  });

  //let handleChangeNavDrawercall = handleChangeNavDrawer.bind(this);

  function handleChangeNavDrawer() {
    setState({
      navDrawerOpen: !state.navDrawerOpen,
    });
  }

  const classes = AppStyles();
  const { navDrawerOpen } = state;

  return (
    <Switch>
      <Suspense fallback={<>Loading ... </>}>
        {/* <Route path="*">
          <Redirect to="/railways" />
        </Route> */}
        <Route exact path={`/${LobConstants.LOB}`} component={RailwaysHomePage} />
        <Route exact path={`/${LobConstants.LOB}/dashboard`} component={Dashboard} />
        <Route path={`/${LobConstants.LOB}`} component={Job} />
        <Route path={`/${LobConstants.LOB}`} component={Maintenance} />
        <Route path={`/${LobConstants.LOB}`} component={Invoice} />
        <Route path={`/${LobConstants.LOB}`} component={Dsr} />
        <Route path={`/${LobConstants.LOB}`} component={DamageWagon} />
        <Route path={`/${LobConstants.LOB}`} component={TrackRake} />
        <Route path={`/${LobConstants.LOB}`} component={RakeMaster} />
        <Route path={`/${LobConstants.LOB}`} component={RouteMaster} />
        <Route path={`/${LobConstants.LOB}`} component={CommodityMaster} />
        <Route path={`/${LobConstants.LOB}`} component={Master} />
        <Route path={`/${LobConstants.LOB}`} component={RakeInduction} />
        <Route path={`/${LobConstants.LOB}`} component={RakeMaintenance} />
        <Route path={`/${LobConstants.LOB}`} component={ContractDetails} />
        <Route path={`/${LobConstants.LOB}`} component={VendorDetails} />
        <Route path={`/${LobConstants.LOB}`} component={ShipToPartyDetails} />
        <Route
          path={`/${LobConstants.LOB}`}
          component={SapTransactionDetails}
        />
        <Route path={`/${LobConstants.LOB}`} component={MonthlyReport} />
        <Route path={`/${LobConstants.LOB}`} component={ConsolidatedInvoice} />
        <Route path={`/${LobConstants.LOB}`} component={MgtInvoice} />

        {/* <Route path={`/${LobConstants.LOB}/reports/dailypositionreport`} component={DailyPositionReport} />
        <Route path={`/${LobConstants.LOB}/reports/executivedashboard`} component={ExecutiveDashboard} /> */}

        <Route path={`/${LobConstants.LOB}/reports/rakedetentionreport`} component={RakeDetentionReport} />
        <Route path={`/${LobConstants.LOB}/reports/tonnagereport`} component={TonnageReport} />
        <Route path={`/${LobConstants.LOB}/reports/idelWeightReport`} component={IdelWeightReport} />
        <Route path={`/${LobConstants.LOB}/reports/tripwiseProfitabilityReport`} component={TripWiseProfitablityReport} />
        <Route path={`/${LobConstants.LOB}/reports/sftoJobDetailsReport`} component={SFTOJobdetailsReport} />
        <Route path={`/${LobConstants.LOB}/reports/gpwisJobDetailsReport`} component={GPWISJobDetailsReport} />
        <Route path={`/${LobConstants.LOB}/reports/invoicereport`} component={InvoiceReport} />
        {/* <Route path={`/${LobConstants.LOB}/reports/dailypositionreport`} component={DailyPositionReport} />
        <Route path={`/${LobConstants.LOB}/reports/executivedashboard`} component={ExecutiveDashboard} /> */}
        <Route path={`/${LobConstants.LOB}`} component={CustomerThresholdMaster} />
        <Route path={`/${LobConstants.LOB}`} component={ReportView} />
        <Route path={`/${LobConstants.LOB}`} component={MaterialClassMaster} />
        <Route path={`/${LobConstants.LOB}`} component={FrieghtMaster} />
        <Route path={`/${LobConstants.LOB}`} component={DepoMaster} />
        <Route path={`/${LobConstants.LOB}`} component={WagonComponentMaster} />

        <Route path={`/${LobConstants.LOB}`} component={RakeRebateMaster} />
        <Route path={`/${LobConstants.LOB}`} component={ODPairMaster} />
        <Route
          path={`/${LobConstants.LOB}`}
          component={TATReconciliationMaster}
        />
        <Route path={`/${LobConstants.LOB}`} component={StationMaster} />
        <Route
          path={`/${LobConstants.LOB}/reports/invoicegenreport`}
          component={RakeRebateInvoice}
        />
        {/* <Route path={`/${LobConstants.LOB}`} component={Invoice} />
        <Route path={`/${LobConstants.LOB}`} component={Maintenance} /> */}
        <Route path={`/${LobConstants.LOB}`} component={ExaminationTypeMaster} />
        {/* <Route path={`/${LobConstants.LOB}`} component={DepoMaster} /> */}
        <Route path={`/${LobConstants.LOB}`} component={RohPohScheduleComponentMaster} />
        {/* <Route path={`/${LobConstants.LOB}`} component={MgtInvoice} /> */}
        <Route path={`/${LobConstants.LOB}`} component={SFTOReconciliationRouts} />
      </Suspense>
    </Switch>
  );
}
